import { slideshow } from 'uikit';
import 'alpinejs';

import './utility/scroll-direction-detection';
import './utility/header-height';

import './components/navigation';
import './components/pagination';

import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import isotope from 'isotope-layout';
jQueryBridget('isotope', isotope, $);

function getHashFilter()
{
	var matches = location.hash.match( /filter=([^&]+)/i );
	var hashFilter = matches && matches[1];
	return hashFilter && decodeURIComponent( hashFilter );
}

// init Isotope
var $grid = $('.jsFilterGrid');

// bind filter button click
var $filterButtonGroup = $('.js-filter-button-group');
$filterButtonGroup.on( 'click', 'button', function() {
	var filterAttr = $( this ).attr('data-filter');
	location.hash = 'filter=' + encodeURIComponent( filterAttr );
});

var isIsotopeInit = false;

function onHashchange() {
	var hashFilter = getHashFilter();
	if ( !hashFilter && isIsotopeInit ) {
		return;
	}
	isIsotopeInit = true;
	// filter isotope
	$grid.isotope({
		itemSelector: '.filterItem',
		layoutMode: 'fitRows',
		percentPosition: true,
		fitRows: {
			gutter: '.gutter-sizer'
		},
		filter: hashFilter
	});
	// set selected class on button
	if ( hashFilter ) {
		$filterButtonGroup.find('.is-checked').removeClass('is-checked');
		$filterButtonGroup.find('[data-filter="' + hashFilter + '"]').addClass('is-checked');
	}
}

$(window).on( 'hashchange', onHashchange );

// trigger event handler to init Isotope
onHashchange();

var markers = [];
$(window).on('load', function(){

    let markerId = document.getElementById("properties-map");

	if (markerId)
	{

		let pos = {};
		var bounds = new google.maps.LatLngBounds();
		var myLatlng = new google.maps.LatLng(40.2325485,-88.4228806);
		let markersJson = JSON.parse(markerId.dataset.marker);
		var infoWindow = new google.maps.InfoWindow();
		var style = [{"featureType": "all", "elementType": "geometry.fill", "stylers": [{"weight": "2.00"} ] }, {"featureType": "all", "elementType": "geometry.stroke", "stylers": [{"color": "#9c9c9c"} ] }, {"featureType": "all", "elementType": "labels.text", "stylers": [{"visibility": "on"} ] }, {"featureType": "landscape", "elementType": "all", "stylers": [{"color": "#f2f2f2"} ] }, {"featureType": "landscape", "elementType": "geometry.fill", "stylers": [{"color": "#ffffff"} ] }, {"featureType": "landscape.man_made", "elementType": "geometry.fill", "stylers": [{"color": "#ffffff"} ] }, {"featureType": "poi", "elementType": "all", "stylers": [{"visibility": "off"} ] }, {"featureType": "road", "elementType": "all", "stylers": [{"saturation": -100 }, {"lightness": 45 } ] }, {"featureType": "road", "elementType": "geometry.fill", "stylers": [{"color": "#eeeeee"} ] }, {"featureType": "road", "elementType": "labels.text.fill", "stylers": [{"color": "#7b7b7b"} ] }, {"featureType": "road", "elementType": "labels.text.stroke", "stylers": [{"color": "#ffffff"} ] }, {"featureType": "road.highway", "elementType": "all", "stylers": [{"visibility": "simplified"} ] }, {"featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{"visibility": "off"} ] }, {"featureType": "transit", "elementType": "all", "stylers": [{"visibility": "off"} ] }, {"featureType": "water", "elementType": "all", "stylers": [{"color": "#46bcec"}, {"visibility": "on"} ] }, {"featureType": "water", "elementType": "geometry.fill", "stylers": [{"color": "#c8d7d4"} ] }, {"featureType": "water", "elementType": "labels.text.fill", "stylers": [{"color": "#070707"} ] }, {"featureType": "water", "elementType": "labels.text.stroke", "stylers": [{"color": "#ffffff"} ] } ];
		var marker;

		var mapOptions = {
			zoom: 7,
			minZoom: 5,
			center: myLatlng,
			styles: style
		};
		var map = new google.maps.Map(markerId, mapOptions);
		markersJson.forEach(setMarkers);

		function setMarkers(item, index) {
			var myLatlng = new google.maps.LatLng(item.lat, item.lng);
			marker = new google.maps.Marker({
				position: myLatlng,
				icon: item.category != null ? "/assets/images/" + item.category + ".svg" : "",
				title: item.title,
				handle: item.handle,
				category: item.category
			});

			google.maps.event.addListener(marker, 'click', (function(marker, i) {
				return function() {
					infoWindow.setContent(item.info);
					infoWindow.open(map, marker);
				}
			})(marker));

			markers.push(marker);

			// To add the marker to the map, call setMap();
			var zoomChangeBoundsListener =
			google.maps.event.addListener(map, 'bounds_changed', function(event) {
				google.maps.event.removeListener(zoomChangeBoundsListener);
				map.setZoom( Math.min( 16, map.getZoom() ) );
			});

			bounds.extend(myLatlng);
			marker.setMap(map);
		}

		// Parse the query parameters to get the marker identifier
		function getQueryParam(param) {
			var urlParams = new URLSearchParams(window.location.search);
			return urlParams.get(param);
		}

		// Get the marker identifier from the URL
		var markerToOpen = getQueryParam('marker');

		// Was a marker specified?
		if (markerToOpen)
		{
			// Get the marker you want to open
			let targetMarker = markers.find(m => m.handle === markerToOpen);
			if (targetMarker)
			{
				// Trigger a click on the target marker to open the InfoWindow
				google.maps.event.trigger(targetMarker, 'click');
				// Scroll to the map
				markerId.scrollIntoView({ behavior: "smooth", block: "center" });
			}
			else
			{
				console.error('Specified marker not found.');
			}
		}

		$(document).on('click', '.filter-toggle', function(event) {
			event.preventDefault();
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(this).find('svg').addClass('opacity-0');
			} else {
				$(this).addClass('active');
				$(this).find('svg').removeClass('opacity-0');
			}

			displayMarkers();
		});

		function displayMarkers(category)
		{
			var i;
			for (i = 0; i < markers.length; i++)
			{
				markers[i].setVisible(false);
			}

			$('.filter-toggle.active').each(function(index, el) {
				for (i = 0; i < markers.length; i++)
				{
					if (markers[i].category === $(this).data('category'))
					{
						markers[i].setVisible(true);
					}
				}
			});
		}

		map.fitBounds(bounds);
	} // if markerId
});